import { returnDetail } from '@root/state/reducers/return_disposal/returnDisposalReducer';
import { Form, Input, Row } from 'antd';
import { useEffect, useMemo, useState } from 'react';

interface returnQuantity {
  productId: number;
  productName: string;
  returnQuantity: number;
}
function RecipientReturnForm({
 detailData,
}: {
  detailData: any;
}) {
  const defaultValue = useMemo(() => {
    return {
      recipientName: detailData ? detailData?.sellerName : '',
      recipientPhone: detailData ? detailData?.sellerPhoneNumber : '',
      country: detailData ? detailData?.sellerCountry : '',
      returnAddress: detailData ? detailData?.sellerDetailAddress : '',
      detailReturnAddress: detailData ? detailData?.sellerDetailAddress2 : '',
      detailReturnAddress2: detailData ? detailData?.sellerDetailAddress3 : '',
      city: detailData ? detailData?.sellerCity : '',
      state: detailData ? detailData?.sellerState : '',
      postalCode: detailData ? detailData?.sellerPostalCode : '',
    };
  }, [detailData]);

  return (
    detailData && detailData.id ?
      <Form
        initialValues={{
          recipientName: defaultValue.recipientName,
          recipientPhone: defaultValue.recipientPhone,
          country: defaultValue.country,
          returnAddress: defaultValue.returnAddress,
          detailReturnAddress: defaultValue.detailReturnAddress,
          detailReturnAddress2: defaultValue.detailReturnAddress2,
          city: defaultValue.city,
          state: defaultValue.state,
          postalCode: defaultValue.postalCode,
        }}
      >
        <Form.Item
          style={{
            display: 'inline-block',
            width: '45%',
            marginRight: '30px'
          }}
        >
          <Form.Item
            label="Recipient Name"
            name="recipientName"
            style={{
              display: 'inline-block',
              width: '40%',
              marginRight: '30px'
            }}
          >
            <Input className="inputRadious" disabled={true} />
          </Form.Item>
          <Form.Item
            label="Recipient Phone Number"
            name="recipientPhone"
            style={{
              display: 'inline-block',
              width: '50%'
            }}
          >
            <Input className="inputRadious" disabled={true} />
          </Form.Item>
        </Form.Item>
        <Form.Item style={{ display: 'inline-block', width: 'calc(55% - 30px)' }}>
          <Form.Item
            label="Shipping Country/Address"
            name="country"
            style={{ display: 'inline-block', width: '35%' }}
          >
            <Input className="inputRadious" disabled={true} />
          </Form.Item>
          <Form.Item
            name="returnAddress"
            style={{
              display: 'inline-block',
              width: '65%',
              marginTop: '32px',
              paddingLeft: '10px'
            }}
          >
            <Input className="inputRadious" disabled={true} />
          </Form.Item>
          <Form.Item
            name="detailReturnAddress2"
            style={{ display: 'inline-block', width: '50%', marginTop: '10px' }}
          >
            <Input className="inputRadious" disabled={true} />
          </Form.Item>
          <Form.Item
            name="detailReturnAddress"
            style={{
              display: 'inline-block',
              width: '50%',
              marginTop: '10px',
              paddingLeft: '10px'
            }}
          >
            <Input className="inputRadious" disabled={true} />
          </Form.Item>
          <Form.Item style={{ marginTop: '10px' }}>
            <Form.Item
              name="city"
              style={{
                display: 'inline-block',
                width: '33%',
                paddingRight: '10px'
              }}
            >
              <Input className="inputRadious" disabled={true} />
            </Form.Item>
            <Form.Item
              name="state"
              style={{
                display: 'inline-block',
                width: '34%',
                paddingRight: '10px'
              }}
            >
              <Input className="inputRadious" disabled={true} />
            </Form.Item>
            <Form.Item
              name="postalCode"
              style={{
                display: 'inline-block',
                width: '33%'
              }}
            >
              <Input className="inputRadious" disabled={true} />
            </Form.Item>
          </Form.Item>
        </Form.Item>
      </Form> : <></>
  );
}

export default RecipientReturnForm;
